var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPdf(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.166 4L25 9.834V28H6.2V4h12.966zm-.566.8H7v22.4h17.2V10.4h-5.6V4.8zm-5.276 11.456c1.048 0 1.624.616 1.624 1.92 0 1.304-.584 1.928-1.624 1.928-.4 0-.752-.128-.944-.344v1.416a.43.43 0 01-.432.432.43.43 0 01-.432-.432v-4.44a.43.43 0 01.432-.432.43.43 0 01.432.432c.12-.2.496-.48.944-.48zm5.032-1.952a.43.43 0 01.432.432v3.768c0 1.064-.688 1.6-1.656 1.6-1.08 0-1.712-.616-1.712-1.92 0-1.304.616-1.928 1.624-1.928.384 0 .72.16.88.32v-1.84a.43.43 0 01.432-.432zm-8.176 4.704c.336 0 .52.176.52.536 0 .352-.184.52-.52.52s-.528-.168-.528-.52c0-.36.192-.536.528-.536zm11.152-4.488a.376.376 0 110 .752c-.44 0-.664.248-.664.6v.496h.536c.2 0 .36.16.36.36 0 .2-.16.36-.36.36h-.536v2.56c0 .24-.192.416-.432.416-.256 0-.432-.176-.432-.416v-2.56h-.168c-.2 0-.36-.16-.36-.36 0-.2.16-.36.36-.36h.168v-.432c0-.744.496-1.416 1.528-1.416zm-8.12 2.472c-.56 0-.856.4-.856 1.192 0 .784.296 1.184.856 1.184s.856-.4.856-1.184c0-.792-.296-1.192-.856-1.192zm3.92 0c-.544 0-.856.4-.856 1.192 0 .784.304 1.184.856 1.184.464 0 .792-.312.792-.864V17.4s-.312-.408-.792-.408zM19.4 5.366V9.6h4.234L19.4 5.366z"
  }));
}

export default SvgPdf;